/* eslint-disable @typescript-eslint/no-explicit-any */

import { MultiSelect, ToolsCard } from "./components";
import { useEffect, useState } from "react";
import { useStaticData } from "@/Providers/Data";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";

export default function CreatorTools() {
  const staticDataState = useStaticData();

  const [allToolList, setALLToolList] = useState<
    {
      toolCategory: string;
      toolIcon?: string;
      toolName: string;
      toolWebsite: string;
      toolDescription: string;
      toolSubDescription: string;
    }[]
  >([]);
  const [allFilters, setAllFilters] =
    useState<{ key: string; value: string }[]>();
  const [FilteredToolList, setFilteredToolList] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  useEffect(() => {
    async function getCreatorTools() {
      const result = await staticDataState?.getNewDataFromType("Creator Tools");
      setALLToolList(result);
    }
    getCreatorTools();
  }, [staticDataState]);
  useEffect(() => {
    let options: { key: string; value: string }[] | string[] = allToolList?.map(
      (item) => item?.toolCategory
    );
    options = [...new Set(options)];
    options = options?.map((item) => {
      return { key: item, value: item };
    });
    setAllFilters(options);
  }, [allToolList]);
  useEffect(() => {
    if (selectedFilters?.length) {
      setFilteredToolList(
        allToolList
          ?.map((item) => {
            if (selectedFilters?.includes(item?.toolCategory)) {
              return item;
            }
          })
          ?.filter((item) => item)
      );
    } else {
      setFilteredToolList(allToolList);
    }
  }, [selectedFilters, allToolList]);

  return (
    <>
      <MobileMenuBar />
      <div className="bg-background-dark text-foreground-bright dark mb-[100px] ">
        <main className="container flex flex-col gap-[30px] mx-auto px-4 py-12 md:px-6 lg:px-8">
          <div className="w-full flex items-center justify-between">
            <h1 className="text-[14px] item-center md:text-[24px] font-[600] text-[#FFFFFF]">
              AI Tools for Creators
            </h1>
            <MultiSelect
              values={allFilters}
              selectedValue={selectedFilters}
              setSelectedValue={setSelectedFilters}
            />
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {FilteredToolList?.map(
              (
                {
                  toolCategory,
                  toolDescription,
                  toolName,
                  toolWebsite,
                  toolIcon,
                  toolSubDescription,
                },
                index
              ) => (
                <ToolsCard
                  key={index}
                  toolName={toolName}
                  toolWebsite={toolWebsite}
                  toolDescription={toolDescription}
                  toolCategory={toolCategory}
                  toolIcon={toolIcon}
                  toolSubDescription={toolSubDescription}
                />
              )
            )}
          </div>
        </main>
      </div>
    </>
  );
}
